import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";

import { getTopicPage } from "../configureStore";
import { fetchTopicPage } from "../configureStore/topicPage";
import { getHelmet } from "../utilities";
import { FromTopPage } from "../theme";
import PageLoader from "../components/loader/PageLoader";
import NotFound from "../components/NotFound";
import Error from "../components/Error";
import TopicPage from "../components/topic/TopicPage";
import JoinUs from "../components/JoinUs";

class Topic extends Component {
  static fetchInitialData({ slug }) {
    return [fetchTopicPage(slug)];
  }

  componentDidMount() {
    this.fetchContent();
  }

  componentDidUpdate() {
    this.fetchContent();
  }

  fetchContent() {
    const { topicPage, dispatch, match } = this.props;

    if (!topicPage.isFetching && !topicPage.error && !topicPage.isLoaded) {
      dispatch(fetchTopicPage(match.params.slug));
    }
  }

  render() {
    const { error, isLoaded, topic } = this.props.topicPage;

    if (error) {
      if (error === "404") {
        return <NotFound />;
      }

      return <Error message={error} />;
    }

    if (isLoaded) {
      const microdata = {
        "@context": "https://schema.org",
        "@type": "NewsArticle",
        isAccessibleForFree: "http://schema.org/True",
        mainEntityOfPage: {
          "@type": "WebPage",
          "@id": `${process.env.RAZZLE_HOSTNAME}/dossiers/${topic.slug}`,
        },
        headline: topic.title,
        image: {
          "@type": "ImageObject",
          url: topic.thumb_hero_url,
          width: 1920,
          height: 960,
        },
        datePublished: topic.published_at,
        dateModified: topic.published_at,
        publisher: {
          "@type": "Organization",
          name: "Le Média",
          logo: {
            "@type": "ImageObject",
            url: "http://ressources.lemediatv.fr/logo-microdata.png",
            width: 300,
            height: 60,
          },
          url: "https://lemediatv.fr",
        },
        description: topic.headline_medium,
      };

      return (
        <FromTopPage>
          <Helmet>
            {getHelmet(
              topic.title,
              topic.headline_medium,
              this.props.match.url,
              topic.thumb_hero_url
            )}

            <script type="application/ld+json">
              {JSON.stringify(microdata)}
            </script>
          </Helmet>
          <TopicPage topic={topic} />
          <JoinUs />
        </FromTopPage>
      );
    }

    return <PageLoader />;
  }
}

Topic.propTypes = {
  dispatch: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      slug: PropTypes.string.isRequired,
    }).isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  topicPage: PropTypes.shape({
    isFetching: PropTypes.bool.isRequired,
    error: PropTypes.string,
    isLoaded: PropTypes.bool.isRequired,
    topic: PropTypes.shape({
      slug: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      headline_medium: PropTypes.string.isRequired,
      thumb_hero_url: PropTypes.string.isRequired,
      published_at: PropTypes.string.isRequired,
    }),
  }),
};

export default connect((state, { match }) => ({
  topicPage: getTopicPage(state, match.params.slug),
}))(Topic);
